import React, { useState } from "react";
import axios from "axios";
import { Context} from 'react-mathjax2';


function CalculoRaices(){
     // Definimos los estados de nuestros coeficientes y soluciones
  const [a, setA] = useState(0);
  const [b, setB] = useState(0);
  const [c, setC] = useState(0);
  const [solucion1, setSolucion1] = useState(null);
  const [solucion2, setSolucion2] = useState(null);

// Definimos la función resolver, que realiza una petición POST al servidor
  const resolver = async () => {
// Hacemos la petición al servidor y obtenemos la respuesta
   // const response = await axios.post("http://localhost:5000/resolver", {a,b,c,});
  const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/resolver`, {a,b,c,});

  
// Extraemos los datos de la respuesta
    const data = response.data;

// Si hay un error, lo mostramos. Si no, actualizamos las soluciones
    if (data.error) {
      alert(data.error);
    } else {
      setSolucion1(data.solucion1);
      setSolucion2(data.solucion2);
    }
  };

  return (
    <Context input="tex">

    <div className="App">
      <h1 className="title">
      Calcular raíces de ecuaciones cuadráticas <br /> 
      A x<sup>2</sup> + B x + C = 0 
      </h1>
    <div>
      
    <label>
      <span> 
        <input type="number" value={a} onChange={(e) => setA(e.target.value)} placeholder="a" /> 
      </span>

      <span className="math"> 
        X<sup>2</sup> + 
      </span>  

    </label>

    <label>
     <span> 
      <input type="number" value={b} onChange={(e) => setB(e.target.value)} placeholder="b" /> 
     </span>
     <span className="math">
       X + 
     </span> 
    </label>

    <label>
      <span> 
        <input type="number" value={c} onChange={(e) => setC(e.target.value)} placeholder="c" /> 
      </span>
       <span className="math"> 
       = 0 
       </span>
      </label>
      
      </div>
      
      <button onClick={resolver}> Resolver Ecuación Cuadrática</button>
      <h2>
        Soluciones:&nbsp;&nbsp;X<sub>1</sub>= {solucion1}, &nbsp; &nbsp; X<sub>2</sub>= {solucion2}
      </h2>

      <p style={{ display: 'flex', alignItems: 'center' }}>
       Nota:  
       <img src="/numero_imaginario_SF.png" alt="número imaginario" style={{ width: '100px' }} />
      </p>

    </div>
    </Context>
    );
}

export default CalculoRaices;